import { traverseHtmlElements } from '@flow/libs/html/utils/traverseHtmlElements';

/** Clean docx image elements. */
export const cleanDocxImageElements = (rootNode: Node): void => {
  traverseHtmlElements(rootNode, (element) => {
    if (element.tagName === 'IMG') {
      const src = element.getAttribute('src');

      if (src?.startsWith('file://')) {
        // Word outputs file:// <img> tags nested inside two wrapper elements (e.g. a VML conditional block and its container).
        // Removing two levels ensures both the <img> and its empty parent wrappers are removed cleanly.
        const outer = element.parentElement?.parentElement;
        if (outer && outer.parentNode) {
          // Insert an empty paragraph in place of the removed image and its wrappers
          const emptyParagraph = document.createElement('p');
          outer.parentNode.replaceChild(emptyParagraph, outer);
        }
        return false;
      }
    }

    return true;
  });
};
